import { Link } from 'react-router-dom'
import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	CardDescription,
} from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import { SectionHeader } from '../SectionHeader'
import { embedCode, placeholderWidgetId } from '../constants'
import { useTranslation } from '@/hooks/useTranslation'

export const GeneralInstallationSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="general-installation" className="mb-16">
			<SectionHeader id="general-installation">
				{t('docs.generalInstallation.title')}
			</SectionHeader>

			<Card className="mb-8 shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle className="text-xl font-semibold flex items-center gap-2">
						<span className="flex items-center justify-center w-6 h-6 bg-primary/10 text-primary rounded-full text-sm font-bold">
							1
						</span>
						{t('docs.generalInstallation.step1.title')}
					</CardTitle>
				</CardHeader>
				<CardContent className="text-gray-700 dark:text-gray-300 space-y-3">
					<p>
						{t('docs.generalInstallation.step1.description')}
					</p>
					<ul className="list-disc pl-5 space-y-1 text-sm">
						<li>
							{t('docs.generalInstallation.step1.listItem1.prefix')}{' '}
							<Link
								to="/widgets"
								className="text-primary hover:underline font-medium">
								{t('docs.generalInstallation.step1.listItem1.linkText')}
							</Link>{' '}
							{t('docs.generalInstallation.step1.listItem1.suffix')}
						</li>
						<li>{t('docs.generalInstallation.step1.listItem2')}</li>
						<li>
							{t('docs.generalInstallation.step1.listItem3')}
						</li>
						<li>
							{t('docs.generalInstallation.step1.listItem4.prefix')}{' '}
							<strong className="font-semibold">{t('docs.generalInstallation.step1.listItem4.widgetId')}</strong>{' '}
							{t('docs.generalInstallation.step1.listItem4.suffix')}
						</li>
					</ul>
				</CardContent>
			</Card>

			<Card className="mb-8 shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle className="text-xl font-semibold flex items-center gap-2">
						<span className="flex items-center justify-center w-6 h-6 bg-primary/10 text-primary rounded-full text-sm font-bold">
							2
						</span>
						{t('docs.generalInstallation.step2.title')}
					</CardTitle>
					<CardDescription className="dark:text-gray-400">
						{t('docs.generalInstallation.step2.description')}
					</CardDescription>
				</CardHeader>
				<CardContent>
					<CodeBlock
						code={embedCode}
						language="html"
						copyLabel={t('docs.generalInstallation.step2.copyLabel')}
						copyMessage={t('docs.generalInstallation.step2.copyMessage')}
					/>
					<p className="mt-3 text-sm text-muted-foreground dark:text-gray-400">
						{t('docs.generalInstallation.step2.replaceHint.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs font-semibold">
							{placeholderWidgetId}
						</code>{' '}
						{t('docs.generalInstallation.step2.replaceHint.suffix')}
					</p>
				</CardContent>
			</Card>
		</section>
	)
}